/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Required_MarkerInputs */

const en_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const de_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflichtfeld`)
};

const fr_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obligatoire`)
};

const es_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obligatorio`)
};

const it_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obbligatorio`)
};

const nl_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verplicht`)
};

const pl_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymagane`)
};

const fi_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakollinen`)
};

const da_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paakraevet`)
};

const sv_consent_required_marker = /** @type {(inputs: Consent_Required_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obligatoriskt`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Consent_Required_MarkerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_required_marker = /** @type {((inputs?: Consent_Required_MarkerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Required_MarkerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_required_marker(inputs)
	if (locale === "fr") return fr_consent_required_marker(inputs)
	if (locale === "es") return es_consent_required_marker(inputs)
	if (locale === "it") return it_consent_required_marker(inputs)
	if (locale === "nl") return nl_consent_required_marker(inputs)
	if (locale === "pl") return pl_consent_required_marker(inputs)
	if (locale === "fi") return fi_consent_required_marker(inputs)
	if (locale === "da") return da_consent_required_marker(inputs)
	if (locale === "sv") return sv_consent_required_marker(inputs)
	return en_consent_required_marker(inputs)
});